module.exports = __webpack_public_path__ + "static/media/instabus.0458b533.png";